import {runWebviewToAppBridge} from '~/common/utils/webview';

export const webviewSendRsvpDetails = (payload) => {
  runWebviewToAppBridge('viewInvitationSetRsvp', JSON.stringify(payload));
};

export const webviewOpenEventOverview = (payload) => {
  runWebviewToAppBridge('viewInvitationOpenEventOverview', JSON.stringify(payload));
};
